module.exports = __webpack_public_path__ + "img/image11.a36dfb8a.png";